import { isRejectedWithValue } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const getErrorMessage = (status, data) => {
  console.warn("Status:", status, "Data:", data);

  switch (status) {
    case 400:
    case 404:
      if (data?.errors && typeof data.errors === "object") {
        const errorMessages = Object.entries(data.errors).reduce(
          (acc, [field, messages]) => {
            acc[field] = Array.isArray(messages)
              ? messages.join(", ")
              : messages;
            return acc;
          },
          {}
        );
        return errorMessages;
      } else if (data?.error && typeof data.error === "object") {
        const errorMessages = Object.entries(data.error).reduce(
          (acc, [field, messages]) => {
            acc[field] = Array.isArray(messages)
              ? messages.join(", ")
              : messages;
            return acc;
          },
          {}
        );
        return errorMessages;
      } else if (data?.errors && typeof data.errors === "string") {
        return { general: data.errors };
      } else if (data?.error && typeof data.error === "string") {
        return { general: data.error };
      }
      return { general: "Bad Request. Please check your input." };
    case 401:
      return { general: "Unauthorized! Please log in again." };
    case 403:
      return {
        general:
          data?.message || "You don't have permission to perform this action.",
      };
    case 500:
      return { general: "Internal Server Error. Please try again later." };
    default:
      return {
        general: data?.message || "An error occurred. Please try again.",
      };
  }
};

const showError = (message) => {
  // console.error("errorMessage", message);
  if (message === "The link has been expired."||message==="An error occurred. Please try again.") {
    toast.error(message);
  }
};

export const apiErrorMiddleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { status, data } = action.payload || {};

    const errorMessages = getErrorMessage(status, data);
    if (errorMessages.general) {
      showError(errorMessages.general);
    }

    if (status === 400 && errorMessages) {
      store.dispatch({
        type: "form/setFieldErrors",
        payload: errorMessages,
      });
    }
  }

  return next(action);
};
